(function(){
  // selector de todos los componentes (puedes tener varios en la página)
  const components = document.querySelectorAll('.choppypy-subcats-component');

  if(!components || components.length === 0) return;

  components.forEach(function(root, index){
    // asignar IDs accesibles si no existen
    const list = root.querySelector('.choppypy-subcats-list');
    const toggle = root.querySelector('.choppypy-subcats-toggle');

    // seguridad: si no hay lista, nada que hacer
    if(!list || !toggle) return;

    // asignar id único si falta
    if(!list.id){
      list.id = 'choppypy-subcats-list-' + index;
    }
    toggle.setAttribute('aria-controls', list.id);

    // Asegurar que todos los anchors tengan la clase 'choppypy-subcat' para estilos
    Array.prototype.slice.call(list.querySelectorAll('a')).forEach(function(a){
      if(!a.classList.contains('choppypy-subcat')){
        a.classList.add('choppypy-subcat');
      }
      // opcional: cuando se pulse un enlace en mobile, cerramos el listado
      a.addEventListener('click', function(){
        if(window.matchMedia('(max-width:1000px)').matches){
          root.classList.remove('choppypy-open');
          toggle.setAttribute('aria-expanded', 'false');
          list.setAttribute('aria-hidden', 'true');
        }
      });
    });

    // función para establecer estado
    function setOpen(open){
      if(open){
        root.classList.add('choppypy-open');
        toggle.setAttribute('aria-expanded','true');
        list.setAttribute('aria-hidden','false');
      } else {
        root.classList.remove('choppypy-open');
        toggle.setAttribute('aria-expanded','false');
        list.setAttribute('aria-hidden','true');
      }
    }

    // click y teclado (Enter / Space) sobre el toggle
    toggle.addEventListener('click', function(e){
      e.preventDefault();
      const isOpen = root.classList.contains('choppypy-open');
      setOpen(!isOpen);
    });

    toggle.addEventListener('keydown', function(e){
      if(e.key === 'Enter' || e.key === ' '){
        e.preventDefault();
        toggle.click();
      }
    });

    // cerrar al hacer clic fuera (solo cuando está abierto y en mobile)
    document.addEventListener('click', function(e){
      if(!root.classList.contains('choppypy-open')) return;
      if(window.matchMedia('(min-width:1001px)').matches) return; // solo mobile behavior
      if(!root.contains(e.target)){
        setOpen(false);
      }
    });

    // cerrar/ajustar cuando se hace resize a >1000 (mantener consistente)
    let resizeTimer;
    window.addEventListener('resize', function(){
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function(){
        if(window.matchMedia('(min-width:1001px)').matches){
          setOpen(false);
        }
      }, 120);
    });

    // estado inicial accesible
    setOpen(false);
  });
})();
